export default "__VITE_ASSET__CyHDbBsU__"